import { useAsync } from '@arcxmoney/arcx-react'
import { BigNumber } from 'ethers'
import React from 'react'
import { useServices } from '../../contexts/ServicesContext'
import { PositionState, UserReward } from '../../models/UserReward'
import { AmountG } from '../AmountG'
import { Owner } from '../Owner'
import { Spinner } from '../Spinner'
import { Title } from '../Title'
import './LeaderBoard.scss'
import { LeaderBoardTabs } from './LeaderBoardTabs'
import { Leaders } from './Leaders'

interface IProps {
  tabsIncluded?: boolean
}

export function LeaderBoard({ tabsIncluded = false }: IProps) {
  const { arcxApi } = useServices()
  const [userRewards] = useAsync<UserReward[]>(() => arcxApi.getUserRewards(), [])

  if (!userRewards || userRewards.length === 0) {
    return (
      <>
        <Title
          title="Leaderboard"
          className="leaderboards__title"
          description="See where you rank relative to other farmers involved with ARCx"
        />
        <Spinner />
      </>
    )
  }

  const [first, second, third, ...sortedUserRewards] = userRewards.sort((ur1, ur2) =>
    BigNumber.from(ur2.earned).sub(ur1.earned).gte('0') ? 1 : -1,
  )

  const evaluateArrowState = (positionState: PositionState) => {
    if (positionState === PositionState.Increased) {
      return 'up'
    }
    if (positionState === PositionState.Decreased) {
      return 'down'
    }
  }

  function returnTableRow(rank: number, userReward: UserReward) {
    return (
      <tr key={`${rank}-${userReward.user}`}>
        <td className="rank">{rank}</td>
        <td>
          <Owner address={userReward.user} />
        </td>
        <td>
          <AmountG
            value={userReward.earned}
            arrow={evaluateArrowState(userReward.leaderBoardPositionState)}
          />
        </td>
      </tr>
    )
  }

  return (
    <div className="leaderboards">
      <Title
        title="Leaderboard"
        className="leaderboards__title"
        description="See where you rank relative to other farmers involved with ARCx"
      />
      {tabsIncluded && <LeaderBoardTabs />}
      <Leaders first={first} second={second} third={third} />
      <table className="leaderboard-table">
        <thead>
          <tr>
            <th>Rank</th>
            <th>Owner</th>
            <th>Change</th>
          </tr>
        </thead>
        <tbody>{sortedUserRewards.map((data, i) => returnTableRow(i + 4, data))}</tbody>
      </table>
    </div>
  )
}
